import { UnidadeOrcamentariaService } from "../../../services/UnidadeOrcamentariaService";
import Breadcrumb from "../../../components/breadcrumbs/Breadcrumb.vue";
import UnidadeOrcamentariaForm from "../../../components/forms/UnidadeOrcamentariaForm.vue";

export default {
    name: "EditarUnidadeOrcamentaria",
    components: {
        Breadcrumb,
        UnidadeOrcamentariaForm
    },
    data: () => ({
        breadcrumbs: [
            {
                text: 'Página Inicial',
                disabled: false,
                href: '/',
            },
            {
                text: 'Gerenciamento de Unidades Orçamentárias',
                disabled: false,
                href: '/gerenciar-unidades-orcamentarias',
            },
            {
                text: 'Editar Unidade Orçamentária',
                disabled: true
            }
        ],
        unidadeOrcamentariaData: null
    }),
    created() {
        this.carregarUnidadeOrcamentaria();
    },
    methods: {
        async carregarUnidadeOrcamentaria() {
            try {
                const response = await UnidadeOrcamentariaService.show(this.$route.params.id);
                if (response?.data) {
                    this.unidadeOrcamentariaData = {
                        id: response.data.id,
                        exercicio: response.data.exercicio,
                        codigo_unidade: response.data.codigo_unidade,
                        nome: response.data.nome,
                        ativo: Boolean(response.data.ativo)
                    };
                } else {
                    console.error('Não foi possível carregar os dados da Unidade Orçamentária.');
                    this.$globalAlert('Erro ao carregar dados da Unidade Orçamentária', 'error');
                }
            } catch (error) {
                console.error('Ocorreu um erro ao carregar os dados da Unidade Orçamentária:', error);
                this.$globalAlert('Erro ao carregar dados da Unidade Orçamentária', 'error');
            }
        },
        async handleSave(formData) {
            try {
                const dataToSend = new FormData();
                dataToSend.append("exercicio", formData.exercicio);
                dataToSend.append("codigo_unidade", formData.codigo_unidade);
                dataToSend.append("nome", formData.nome);
                dataToSend.append("ativo", formData.ativo ? 1 : 0);

                const response = await UnidadeOrcamentariaService.update(this.$route.params.id, dataToSend);
                if (response) {
                    this.$router.push('/gerenciar-unidades-orcamentarias');
                } else {
                    throw new Error('Erro ao atualizar unidade orçamentária');
                }
            } catch (error) {
                console.error('Erro ao salvar:', error);
                this.$globalAlert('Erro ao atualizar Unidade Orçamentária');
            }
        },
        handleCancel() {
            this.$router.push('/gerenciar-unidades-orcamentarias');
        }
    }
};
